import { useState, type FormEvent } from "react";
import type { PrimeStreamFilters } from "../api/primeStream";

interface Props {
  initial: PrimeStreamFilters;
  onApply: (filters: PrimeStreamFilters) => void;
}

export function FilterBar({ initial, onApply }: Props) {
  const [sessionId, setSessionId] = useState(initial.sessionId ?? "");
  const [since, setSince] = useState(initial.since ?? "");
  const [until, setUntil] = useState(initial.until ?? "");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    onApply({
      sessionId: sessionId.trim() || undefined,
      since: since ? new Date(since).toISOString() : undefined,
      until: until ? new Date(until).toISOString() : undefined,
    });
  }

  function handleClear() {
    setSessionId("");
    setSince("");
    setUntil("");
    onApply({});
  }

  return (
    <form className="filter-bar" onSubmit={handleSubmit}>
      <div className="filter-field session">
        <label htmlFor="session-id">Session ID</label>
        <input
          id="session-id"
          type="text"
          placeholder="(all sessions)"
          value={sessionId}
          onChange={(e) => setSessionId(e.target.value)}
        />
      </div>
      <div className="filter-field">
        <label htmlFor="since">Since</label>
        <input
          id="since"
          type="datetime-local"
          value={since}
          onChange={(e) => setSince(e.target.value)}
        />
      </div>
      <div className="filter-field">
        <label htmlFor="until">Until</label>
        <input
          id="until"
          type="datetime-local"
          value={until}
          onChange={(e) => setUntil(e.target.value)}
        />
      </div>
      <div className="filter-actions">
        <button type="submit" className="btn">Apply</button>
        <button type="button" className="btn" onClick={handleClear}>
          Clear
        </button>
      </div>
    </form>
  );
}
